import Header from 'components/headers/bulletins'
import { useState } from 'react'
import Switch from 'react-switch'
import useGetTransparency from './hooks/useGetTransparency'
import useSetTransparency from './hooks/useSetTransparency'
import { useParams } from 'react-router-dom'

export default function MemberTransparency() {
    const { data, isLoading, refetch } = useGetTransparency()
    const [checked, setChecked] = useState<{ [key: string]: boolean }>({
        showOtherRecieverLoans: data
            ? data.transparency_setting.show_others_loans
            : false,
        showOtherWantedLoan: data
            ? data.transparency_setting.show_others_loan_demands
            : false,
        showOtherTransaction: data
            ? data.transparency_setting.show_others_transactions
            : false,
        showOverdue: data
            ? data.transparency_setting.show_others_installments
            : false,
        showOthersData: data
            ? data.transparency_setting.show_other_members
            : false,
        showBalance: data ? data.transparency_setting.show_box_balance : false,
        showDebt: data
            ? data.transparency_setting.show_others_to_be_paid_portion
            : false,
    })
    const handleChangeChecked = (value: string) => {
        const newChecked = { ...checked }
        newChecked[value] = !newChecked[value]
        setChecked(newChecked)
    }
    const { mutate } = useSetTransparency(refetch)
    const { id } = useParams()
    return (
        <div className="  flex flex-col bg-white h-full">
            <div className=" grow-0">
                <Header title="تنظیمات صندوق" />
            </div>
            <div className=" grow px-2">
                <p className=" text-lg my-2">شفافیت اطلاعات صندوق</p>
                <p className=" text-sm">
                    کدام یک از موارد زیر در صندوق به عضو عادی نمایش داده شود:
                </p>
                <hr className=" my-3" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">نمایش وام های دریافتی سایرین</p>
                    <Switch
                        onChange={() =>
                            handleChangeChecked('showOtherRecieverLoans')
                        }
                        checked={checked.showOtherRecieverLoans}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه عضو عادی امکان مشاهده تمامی وام های
                    اعطا شده در صندوق را خواهد داشت
                </p>
                <hr className=" my-2" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">نمایش وام های درخواستی سایرین</p>
                    <Switch
                        onChange={() =>
                            handleChangeChecked('showOtherWantedLoan')
                        }
                        checked={checked.showOtherWantedLoan}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، عضو عادی امکان مشاهده تمامی وام های
                    درخواستی در صندوق را خواهد داشت.
                </p>
                <hr className=" my-2" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">نمایش تراکنش های سایرین</p>
                    <Switch
                        onChange={() =>
                            handleChangeChecked('showOtherTransaction')
                        }
                        checked={checked.showOtherTransaction}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، عضو عادی امکان مشاهده تمامی تراکنش
                    های انجام شده در صندوق را خواهد داشت.
                </p>
                <hr className=" my-2" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">
                        نمایش معوقات وام سایرین (لیبل معوق)
                    </p>
                    <Switch
                        onChange={() => handleChangeChecked('showOverdue')}
                        checked={checked.showOverdue}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، عضو عادی امکان مشاهده تمامی اقساط
                    معوق در صندوق را خواهد داشت.
                </p>
                <hr className=" my-2" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">
                        نمایش اطلاعات سایرین در لیست اعضا
                    </p>
                    <Switch
                        onChange={() => handleChangeChecked('showOthersData')}
                        checked={checked.showOthersData}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، عضو عادی امکان مشاهده اسامی تمامی
                    اعضای صندوق را خواهد داشت.
                </p>
                <hr className=" my-2" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">نمایش موجودی صندوق</p>
                    <Switch
                        onChange={() => handleChangeChecked('showBalance')}
                        checked={checked.showBalance}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، عضو عادی امکان مشاهده موجودی صندوق
                    را خواهد داشت.
                </p>
                <hr className=" my-2" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">
                        نمایش میزان بدهی حق عضویت هر عضو به سایرین
                    </p>
                    <Switch
                        onChange={() => handleChangeChecked('showDebt')}
                        checked={checked.showDebt}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، عضو عادی امکان مشاهده بدهکاری حق
                    عضویت اعضای صندوق را خواهد داشت.
                </p>
            </div>
            <div className=" grow-0">
                <div className=" bg-white py-4 px-4">
                    <button
                        className=" w-full bg-green-1 rounded-2xl text-white py-3"
                        onClick={() => {
                            const payload: ISettingTransparencyPayload = {
                                moneyPool: id,
                                show_others_loans:
                                    checked.showOtherRecieverLoans,
                                show_others_loan_demands:
                                    checked.showOtherWantedLoan,
                                show_others_transactions:
                                    checked.showOtherTransaction,
                                show_other_members: checked.showOthersData,
                                show_others_to_be_paid_portion:
                                    checked.showDebt,
                                show_box_balance: checked.showBalance,
                                show_others_installments: checked.showOverdue,
                            }
                            mutate(payload)
                        }}
                    >
                        ثبت تغییرات
                    </button>
                </div>
            </div>
        </div>
    )
}
